// extracted by mini-css-extract-plugin
export default {"Money":"_4-iO8","Money--isFat":"KYgxG","customCurrencyIcon":"mB5vI","skeleton-progress":"_0Lydh"};